import { render, staticRenderFns } from "./ResumedAlertDetails.vue?vue&type=template&id=dab37dba&scoped=true"
var script = {}
import style0 from "./ResumedAlertDetails.vue?vue&type=style&index=0&id=dab37dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab37dba",
  null
  
)

export default component.exports